import { useTranslation } from 'react-i18next';

/** Contenu du toast affiché quand le live est clôturé pour durée maximale atteinte. */
export default function LiveDurationToast() {
  const { t } = useTranslation('common');
  return (
    <div>
      <p className="font-semibold">{t('liveSettings.durationExceeded.title')}</p>
      <p className="text-sm opacity-80">{t('liveSettings.durationExceeded.body')}</p>
    </div>
  );
}
